import React, { useEffect, useState } from "react";
import { toast } from 'react-toastify';
import Cookies from 'js-cookie';
import CompanyDetails from "./CompanyDetails";
import BankDetails from "./BankDetails";
import Documentation from "./Documentation";
import Declaration from "./Declaration";
import { Link, useNavigate, useParams } from "react-router-dom";

const CustomerView = ({ accessedPermission, accessedModules }) => {
    const { b64id } = useParams();
    const navigate = useNavigate()
    const urlString = window.location.href;
    const url = new URL(urlString);
    const path = url.pathname.slice(1);
    const searchParams = url.search;
    const q = path + searchParams;
    const token = Cookies.get("token");
    let customer_id = atob(b64id)
    useEffect(() => {
        if (!token) {
            toast.error("Please login to continue.");
            navigate(`/login?burl=${encodeURIComponent(q)}`);
        } else {
            if (b64id) {
                customer_id = atob(b64id);

            } else {
                toast.error("Please enter correct url.")
                navigate(-1);
            }
        }

    }, []);

    return (
        <div className="page-wrapper">
            <div className="content">
                <div className="contact-head">
                    <div className="row align-items-center mb-3 ">
                        <div className="col-sm-6">
                            <ul className="contact-breadcrumb">
                                <li className="mb-0">
                                    <Link to={-1}>
                                        <i className="ti ti-arrow-narrow-left" />
                                        Back
                                    </Link>
                                </li>

                            </ul>
                        </div>


                    </div>
                </div>
                <CompanyDetails customer_id={customer_id} />
                <BankDetails customer_id={customer_id} />
                <Documentation customer_id={customer_id} />
                <Declaration customer_id={customer_id} />
            </div>
        </div>

    )
}

export default CustomerView